import { supabase } from '../supabase';

type LogLevel = 'info' | 'warn' | 'error';

class Logger {
    private isProduction = import.meta.env.PROD;

    private async logToSupabase(level: LogLevel, message: string, detail?: any) {
        try {
            await supabase.from('error_logs').insert({
                level,
                message,
                detail: detail ? JSON.stringify(detail) : null,
                url: window.location.href,
                user_agent: navigator.userAgent
            });
        } catch (err) {
            // Fallback to console if database logging fails
            if (!this.isProduction) {
                console.error('Failed to log to Supabase:', err);
            }
        }
    }

    info(message: string, detail?: any) {
        if (!this.isProduction) {
            console.log(`[INFO] ${message}`, detail || '');
        }
        // Optional: Log info to DB if critical
    }

    warn(message: string, detail?: any) {
        if (!this.isProduction) {
            console.warn(`[WARN] ${message}`, detail || '');
        }
        this.logToSupabase('warn', message, detail);
    }

    error(message: string, error?: any, userFeedback = "An unexpected error occurred. Please try again.") {
        if (!this.isProduction) {
            console.error(`[ERROR] ${message}`, error || '');
        }

        this.logToSupabase('error', message, error);

        return userFeedback;
    }
}

export const logger = new Logger();
